import React from 'react';
import { Sun } from 'lucide-react';
export function OutcomesSection() {
  return <section className="w-full bg-sage/10 py-20 px-6 md:px-8" style={{
    paddingTop: '50px',
    paddingBottom: '50px'
  }} data-id="element-199">
      <div className="max-w-3xl mx-auto text-center" data-id="element-200">
        <h2 className="text-3xl md:text-4xl font-bold text-text mb-8" data-id="element-201">
          Qué vas a sentir (realmente)
        </h2>

        <p className="text-xl text-text-light mb-10" data-id="element-202">
          No "motivación". Vas a sentir:
        </p>

        <div className="grid gap-6 md:grid-cols-2 text-left" data-id="element-203">
          {['ok… sé por dónde empezar', 'hoy hice lo mínimo y no me destruí', 'no estoy loca: estoy cansada', 'tengo un sistema'].map((item, idx) => <div key={idx} className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-sm border border-sage/20" data-id="element-204">
              <Sun className="w-6 h-6 text-sage-dark flex-shrink-0" data-id="element-205" />
              <span className="text-lg font-medium text-text" data-id="element-206">{item}</span>
            </div>)}
        </div>
      </div>
    </section>;
}